import React, { useEffect, useMemo } from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import { omit } from 'lodash';
import { useSelector } from 'react-redux';

import { Box, Typography, Stack } from '@mui/material';

import selectors from 'store/selectors';
import UserAvatar from 'components/Avatar';
import { mentionStyle } from './ChatInput.styles';

const ChatInput = ({ value, setValue, placeholder = 'Post a comment' }) => {
  const userList: any = useSelector(selectors.getUserAdmin);

  const users = useMemo(() => {
    return userList
      ?.filter((user) => user?.UserHotel?.status === 'Active')
      .map((user) => ({
        display: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
        ...omit(user, ['UserHotel', 'UserHotels', 'UserAvailabilityStatuses']),
      }));
  }, [userList]);

  const adjustListPosition = () => {
    const suggestions = document.querySelector('.mentions-input__suggestions');
    const suggestionList = document.querySelector(
      '.mentions-input__suggestions__list',
    );
    // get me viewport width
    const viewportWidth = window.innerWidth;

    if (suggestions && suggestionList) {
      const right = suggestions.getBoundingClientRect().right - viewportWidth;

      if (right > -100) {
        (suggestionList as HTMLElement).style.right = '0px';
        (suggestionList as HTMLElement).style.left = 'auto';
      } else {
        (suggestionList as HTMLElement).style.right = 'auto';
        (suggestionList as HTMLElement).style.left = '0px';
      }
    }
  };

  const adjustSuggestionList = () => {
    setTimeout(() => adjustListPosition(), 10);
  };

  useEffect(() => {
    window.addEventListener('keyup', adjustSuggestionList);
    return () => window.removeEventListener('keyup', adjustSuggestionList);
  }, []);

  const renderUserSuggestion = (suggestion, search, highlightedDisplay) => {
    const renderAvatar = () => {
      return (
        <UserAvatar
          width={24}
          height={24}
          userId={suggestion?.id}
          className="avatar"
        />
      );
    };

    return (
      <Box
        sx={{
          px: 1,
          py: 0.5,
          maxWidth: 250,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          {renderAvatar()}
          <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
            {highlightedDisplay}
          </Typography>
        </Stack>
      </Box>
    );
  };

  return (
    <MentionsInput
      placeholder={placeholder}
      style={mentionStyle}
      singleLine={false}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className="mentions-input"
    >
      <Mention
        trigger="@"
        data={users}
        markup="[__display__](__id__)"
        displayTransform={(id, display) => `@${display}`}
        renderSuggestion={renderUserSuggestion}
      />
    </MentionsInput>
  );
};

export default ChatInput;
